/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two columns of items draw a two-circle Venn with the shared count in the middle.`)
};

const es_venn_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos columnas de elementos dibujan un Venn de dos círculos con el recuento compartido en el medio.`)
};

const de_venn_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei Elementspalten zeichnen ein Zwei-Kreis-Venn-Diagramm mit der gemeinsamen Anzahl in der Mitte.`)
};

const nl_venn_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twee kolommen met items tekenen een Venn-diagram met twee cirkels met het gedeelde aantal in het midden.`)
};

const fr_venn_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux colonnes d'éléments tracent un Venn à deux cercles avec le décompte partagé au milieu.`)
};

const it_venn_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due colonne di elementi disegnano un Venn a due cerchi con il conteggio condiviso al centro.`)
};

const pt_br2_venn_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas colunas de itens desenham um Venn de dois círculos com a contagem compartilhada no meio.`)
};

const pt_venn_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas colunas de itens desenham um Venn de dois círculos com a contagem partilhada no centro.`)
};

const ja_venn_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2列の項目から、中央に共有件数を示す2円のベン図が描画されます。`)
};

const zh_venn_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两列项目绘制出一个双圆维恩图，中间显示共享数量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_ex1", locale)
	if (locale === "en") return en_venn_ex1(inputs)
	if (locale === "es") return es_venn_ex1(inputs)
	if (locale === "de") return de_venn_ex1(inputs)
	if (locale === "nl") return nl_venn_ex1(inputs)
	if (locale === "fr") return fr_venn_ex1(inputs)
	if (locale === "it") return it_venn_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_venn_ex1(inputs)
	if (locale === "pt") return pt_venn_ex1(inputs)
	if (locale === "ja") return ja_venn_ex1(inputs)
	return zh_venn_ex1(inputs)
};